// extracted by mini-css-extract-plugin
module.exports = {"PlayButtonOuter":"PlayButton_PlayButtonOuter__2t2Gy","PlayButtonInner":"PlayButton_PlayButtonInner__3jTxK","Icon":"PlayButton_Icon__30WK3","Text":"PlayButton_Text__yDDGs"};